import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OdontoStomatognathicViewModel } from 'src/app/model/odonto/stomatognathic.view';

@Component({
  selector: 'ms-odonto-catalog-item',
  templateUrl: './odonto.catalog-item.component.html',
})
export class OdontoCatalogItemComponent {
  @Input() turn = -1;
  @Input() readonly = false;
  @Input() catalog: OdontoStomatognathicViewModel = {};
  @Output() catalogChange: EventEmitter<OdontoStomatognathicViewModel> =
    new EventEmitter();

  handleChange = () => {
    this.catalogChange.emit(this.catalog);
  };
}
